import React from 'react';
import './Carouseltem.scss';

const CarouselItem: React.FC = props => {
  return <div className="CarouselItem">{props.children}</div>;
};

export default CarouselItem;
